import { FetchService } from "@/shared";
import { sectionsEndpoints, type SectionsEndpointsType } from "./endpoints";
import * as dto from "../dto";


export class SectionsRepository {
 private readonly endpoints: SectionsEndpointsType;
 
  constructor(private readonly fethService: FetchService) {   
    this.endpoints = sectionsEndpoints;
  }

  public fecthCreateSection(payload: dto.CreateSectioDto) {
    const url = this.endpoints.createSection;

    return this.fethService.post({ url, payload })
    .then(data => dto.SectionResponseDto.parseAsync(data));
  }

public fechtGetSections(courses_id: string, params: { limit?: string; page?: string } = {}) {
  const url = this.endpoints.getSections;

  const queryParams: { course_id?: string; limit?: string; page?: string } = {};

  if (courses_id) {
    queryParams.course_id = courses_id;
  }
  if (params.limit) {
    queryParams.limit = params.limit;
  }
  if (params.page) {
    queryParams.page = params.page;
  }
  
  return this.fethService.get({ url, params: queryParams })
    .then(data => dto.SectionsResponseDto.parseAsync(data));
}




  public fechtCurrentSection(id: string) {
    const url = this.endpoints.getSection(id);

    return this.fethService.get({ url })
    .then(data => dto.SectionResponseDto.parseAsync(data));
  }

  public fechtEditSection({ id, payload }: { id: string, payload: dto.EditSectioDto }) {
    const url = this.endpoints.editSection(id);

    return this.fethService.put({ url, payload })
    .then(data => dto.SectionResponseDto.parseAsync(data));
  }
  
  public fechtRemoveSection( id: string ) {
    const url = this.endpoints.editSection(id);
    
    return this.fethService.delete({ url })
    .then(data => dto.SectionRemoveResponseDto.parseAsync(data));
  }


}
